export const ticketsTablesStyle = {
  content: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr 20px',

    gap: '12px',
    alignItems: 'end',
    marginBottom: '12px',

    '@media (max-width: 1023.98px)': {
      gridTemplateColumns: '1.9fr 1fr 1fr 1fr 1fr 20px',
    },
  },

  title: {
    marginBottom: '16px',
    textAlign: 'center',
  },

  ticketsTier: {
    width: '394px',
    maxWidth: '100%',
    '@media (max-width: 1023.98px)': {
      width: '100%',
    },
  },

  price: {
    '& .MuiInputBase-input': {
      padding: '0 12px 0 0 !important',

      '@media (max-width: 1023.98px)': {
        padding: '0 12px  !important',
      },
    },
  },

  button: {
    padding: '10px 16px',
  },

  text: {
    color: 'var(--neutral-300)',
    fontStyle: 'italic',
    fontSize: '12px',
  },

  coverFeeTooltip: {
    display: 'flex',

    '& svg': {
      width: '16px',
      height: '16px',
      '& path': {fill: 'var(--neutral-300)'},
    },
  },

  textWithTooltip: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },

  tree: {
    width: '100%',
    'li ul li .MuiTreeItem-content .MuiTreeItem-label': {padding: '0', borderRadius: '8px', a: {borderRadius: '8px'}},

    '.MuiTreeItem-content': {
      position: 'relative',
      width: '100%',
      borderRadius: '8px',
      padding: 0,
      background: 'none',

      '&.Mui-focused.Mui-selected, &.Mui-selected, &.Mui-selected:hover, &:hover': {
        background: 'none',
      },

      '.MuiTreeItem-label': {
        color: 'var(--neutral-700)',
        padding: '8px 0',
        borderRadius: '8px',
        paddingLeft: 0,

        '.MuiBox-root': {
          display: 'flex',
          gap: '10px',
        },
        a: {
          padding: '10px 5px',
          width: '100%',
          height: '100%',
        },
      },

      '.MuiTreeItem-iconContainer': {
        width: '14px',
      },
    },

    '.Mui-selected.Mui-focused': {
      background: 'none',
    },

    '.MuiCollapse-root': {
      position: 'relative',

      '.MuiTreeItem-content': {
        background: 'none',
        '&:hover': {
          background: 'none',
        },
      },

      '.MuiTreeItem-label': {
        position: 'relative',
        background: 'none',
      },

      '.Mui-selected .MuiTreeItem-label': {
        color: 'var(--primary-500)',
        borderRadius: '8px',
      },
    },
  },
  arrowTop: {
    transform: 'rotate(180deg)',
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  disabledMenuItem: {
    color: 'var(--neutral-300)',
    cursor: 'default',
  },
};
